import {ErroneousServerResult, expectEither, HttpClient, POST} from '@raison/network-facade';
import {invariant} from '@raison/toolbox';
import {AccountId} from '@raison/types';
import {string, type} from 'io-ts';
import {appSessionStorage} from '~/shared/persistence';
import {cryptoSign, TransactionHolder} from '../lib/cryptoSign';

// TODO: import from same level violates FSD, rework organization
import {CryptoCurrencyTrait} from '~/entities/currencies';

export interface BlockchainInfo extends Pick<CryptoCurrencyTrait, 'currencyCode'> {
    networkName: string;
}

export async function signCryptoTransaction(
    http: HttpClient,
    data: {
        holder: TransactionHolder;
        wallet: {
            id: AccountId;
            blockchain: BlockchainInfo;
        };
        codeFromSms: string;
    }
) {
    const hPass = appSessionStorage.hPass.get();
    invariant(!!hPass, 'Password hash was not found');

    const body = {
        uuid: data.holder.two_fa_box_uuid,
        pin: data.codeFromSms,
    };
    const cypherResult = await http('v1/2fa/get', POST(body)).then(
        ...expectEither({
            200: type({key: string}),
            400: ErroneousServerResult,
        })
    );
    if (cypherResult.status === 'Abort') {
        return cypherResult;
    }
    if (cypherResult.status === 400) {
        return {status: 'BadRequest', datum: cypherResult.json.message} as const;
    }

    const sign = cryptoSign(
        cypherResult.json.key,
        data.wallet.blockchain.networkName,
        hPass,
        data.holder,
        data.wallet.blockchain.currencyCode
    );
    return {status: 'Ok', datum: sign} as const;
}
